import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import PRSelect from "../../components/pos/PRSelect";
import db from "../../db/db";

export default function TerminalSelector(props) {
  const { t, i18n } = useTranslation();
  const translate = t;

  useEffect(() => {
    loadTerminals();
  }, []);

  const [terminalMessage, setTerminalMessage] = useState("");
  const [terminal, setTerminal] = useState(null);
  const [enableProceedButton, setEnableProceedButton] = useState(false);
  const [terminalOptions, setTerminalOptions] = useState([]);

  async function loadTerminals() {
    let dbData = await db.terminal.toArray();
    let arr = [];
    for (let d of dbData) {
      arr.push({
        label: d.name,
        value: d,
      });
    }
    setTerminalOptions(arr);
  }

  function onChangeTerminal(v) {
    setTerminalMessage("");
    console.log(v.value.printingMode);
    setTerminal(v);
    if (v.value.printingMode == "CLOUD_PRINT") {
      setEnableProceedButton(true);
    } else if (v.value.printingMode == "BLUETOOTH") {
      //TODO Ask For Printer Type
      setTerminalMessage(
        translate(
          "This Terminal is marked for using Bluetooth Printer but We can not use bluetooth Printer Here , Please use Android app"
        )
      );
      setEnableProceedButton(false);
    } else if (v.value.printingMode == "LOCAL") {
      setEnableProceedButton(true);
    } else {
      setEnableProceedButton(true);
      /*setTerminalMessage(
        translate(
          "Not able to find Terminal level Printer configuration , Please update configuration before trying to use this Terminal"
        )
      );*/
    }
  }
  function onOkayClicked() {
    console.log("####");
    props.setTerminalBean(terminal.value);
    props.checkSaleFlow(terminal.value);
    localStorage.setItem("w_terminal", JSON.stringify(terminal.value));
  }
  return (
    <MScreen
      title={translate("Select Terminal")}
      isMoreMenuEnabled={false}
      rightAction={translate("OK")}
      enbaleRightAction={enableProceedButton}
      onRightAction={onOkayClicked}
      onLogOut={props.onLogOut}
      onRedirectToBack={() => {
        props.setCurrentPage("dashboard");
      }}
      dialogMode={true}
      maxWidth={"sm"}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      content={
        <Grid container>
          <Grid item xs={12}>
            Terminal
          </Grid>
          <Grid item xs={12}>
            <PRSelect
              options={terminalOptions}
              onChange={(e) => {
                onChangeTerminal(e);
              }}
              value={terminal}
            ></PRSelect>
          </Grid>

          <Grid item xs={12}>
            {terminalMessage}
          </Grid>
          <Grid ite style={{ height: "200px" }}></Grid>
        </Grid>
      }
    ></MScreen>
  );
}
